import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { BusinessProductPriceTierDeleteCard } from './components/ProductPriceTierDeleteCard';
import { BusinessProductPriceTierDetailsCard } from './components/ProductPriceTierDetailsCard';

export function BusinessProductPriceTierDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const businessProductPriceTierQueryResults = useQuery({
        queryKey: ['businessProductPriceTier', id],
        queryFn: () =>
            Api.BusinessSpecific.ProductPriceTier.getProductPriceTier(
                Number(id)
            ),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={businessProductPriceTierQueryResults}>
                {data => (
                    <Stack gap={2} sx={{ paddingBottom: 4 }}>
                        <BusinessProductPriceTierDetailsCard
                            businessProductPriceTier={data}
                        />

                        <Can I="delete" a="BusinessProductPriceTier">
                            <BusinessProductPriceTierDeleteCard
                                businessProductPriceTier={data}
                            />
                        </Can>
                    </Stack>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
